import { Component, ViewEncapsulation, Injectable } from "@angular/core";

import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { ExcelStyle } from "ag-grid-community";
import { HeaderGroupComponent } from "../header-group-component/header-group.component";
import { AlarmHistoryActionRendererComponent } from "../actionsRenderer/alarmsHistoryAction.component";
import { AlarmHistoryRendererComponent } from "./alarmHistoryRenderer.component";
import { HttpService } from "../../service/HTTPService/HttpService";
import { DatePipe, JsonPipe } from "@angular/common";
import { openModalService } from "../../service/ModalService/ModalService";
const FileSaver = require("file-saver");
import { GridOptions, Module, ColDef, GridReadyEvent } from "ag-grid-community";

import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { GroupedHeaderervice } from "../../service/GroupingHeaders/groupheader.service";
import { DetailedSiteListRendererComponent } from "../detailedSiteListRenderer/detailedSiteListRenderer.component";
import { UserSettingDataService } from "../../service/userSettingDataService/userSettingData.service";
@Component({
  templateUrl: "alarmHistory.component.html",
  styleUrls: ["alarmHistory.css"],
  encapsulation: ViewEncapsulation.None,
})
@Injectable()
export class AlarmHistoryComponent {
  recordsPerRequest;
  showLoader: boolean = false;
  gridOptions: GridOptions;
  gridData1 = [];
  pageIndex = 1;
  gridApi;
  gridColumnApi;
  paginationPageSize;
  paginationNumberFormatter;
  public showGrid: boolean;
  public rowData: any[];
  columnDefs: any[];
  public rowCount: string;
  public searchProperties;
  context;
  public domLayout: "normal" | "autoHeight" | "print" = "autoHeight";
  frameworkComponents;
  alarmsShowRecordSize;
  recordSize = "";
  pageNumber = "";
  surveyId = "";
  siteid = "";
  formid = "";
  formids = [];
  labels = "";
  imgData = [];
  images = [];
  activeSliderId;
  uistatus = "";
  closeResult: string;
  inistartdate = "";
  iniendDate = "";
  statusArr = [];
  selectedSiteCode = "";
  selectedSiteId = "";
  selectedSiteName = "";
  selectedAlarmPinId = "";
  headers: any;
  gridData: any[] = [];
  alerts: any[] = [];
  correlateArr: any[] = [];
  selectedAlarm = "";
  selectedRowVal = 0;
  correlateDisable = true;
  correlateTT: boolean = false;
  createTTBtn = true;
  disableHisExport;
  lastPageFound;
  PageSize;
  currentPage;
  totalPage;
  totalRowCount;
  disablelastbutton = false;
  selectedAlarmName;
  toDateTime;
  public defaultColDef: ColDef;
  alarmsRecordsSize = [
    { id: "10", value: "10" },
    { id: "20", value: "20" },
    { id: "50", value: "50" },
    { id: "100", value: "100" },
  ];
  userSettings;
  refreshRate;
  constructor(
    private groupHeader: GroupedHeaderervice,
    private http: HttpService,
    private modalService: NgbModal,
    private globals: Globals,
    private datePipe: DatePipe,
    private readonly route: ActivatedRoute,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
    private openModalService: openModalService,
    private userSettingService: UserSettingDataService
  ) {
    const token = sessionStorage.getItem("invUIToken");

    let d = new Date();
    this.userSettingService.getUserSettings().subscribe((settings) => {
      if (settings) {
        this.userSettings = settings;
        this.refreshRate = this.userSettings.userRefreshInterval;
      }
    });

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 150,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      headerComponent: "sortableHeaderComponent",
      headerComponentParams: {
        menuIcon: "fa-bars",
      },
    };
    this.toDateTime = this.datePipe.transform(d, "dd-MM-yyyy HH:mm:ss");
    this.showGrid = true;

    this.alarmsShowRecordSize = this.alarmsRecordsSize[0].id;
    this.paginationPageSize = this.alarmsShowRecordSize;
    this.recordsPerRequest = Number(this.alarmsRecordsSize[0].id);
    this.context = { componentParent: this };
    this.route.queryParams.subscribe((params) => {
      const queryStrings = JSON.parse(window.atob(params["e"]));
      this.selectedSiteId = queryStrings["siteID"].toString();
      this.selectedSiteCode = queryStrings["siteCode"];
      this.selectedSiteName = queryStrings["sitename"];
      this.selectedAlarmPinId = queryStrings["alrPinID"];
      this.selectedAlarmName = queryStrings["alarmName"];
    });
    this.paginationNumberFormatter = function (params) {
      return "[" + params.value.toLocaleString() + "]";
    };
    this.frameworkComponents = {
      alarmsHistoryActionRenderer: AlarmHistoryActionRendererComponent,
      alarmHistoryRenderer: AlarmHistoryRendererComponent,
      detailedSiteList: DetailedSiteListRendererComponent,
    };
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this,
      },
    };
    this.gridOptions.suppressColumnVirtualisation = true;
    let replacedArray: any = [];
    let Base64 = {
      _keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      encode: function (e) {
        let t = "";
        let n, r, i, s, o, u, a;
        let f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
          n = e.charCodeAt(f++);
          r = e.charCodeAt(f++);
          i = e.charCodeAt(f++);
          s = n >> 2;
          o = ((n & 3) << 4) | (r >> 4);
          u = ((r & 15) << 2) | (i >> 6);
          a = i & 63;
          if (isNaN(r)) {
            u = a = 64;
          } else if (isNaN(i)) {
            a = 64;
          }
          t =
            t +
            this._keyStr.charAt(s) +
            this._keyStr.charAt(o) +
            this._keyStr.charAt(u) +
            this._keyStr.charAt(a);
        }
        return t;
      },
      decode: function (e) {
        let t = "";
        let n, r, i;
        let s, o, u, a;
        let f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
          s = this._keyStr.indexOf(e.charAt(f++));
          o = this._keyStr.indexOf(e.charAt(f++));
          u = this._keyStr.indexOf(e.charAt(f++));
          a = this._keyStr.indexOf(e.charAt(f++));
          n = (s << 2) | (o >> 4);
          r = ((o & 15) << 4) | (u >> 2);
          i = ((u & 3) << 6) | a;
          t = t + String.fromCharCode(n);
          if (u != 64) {
            t = t + String.fromCharCode(r);
          }
          if (a != 64) {
            t = t + String.fromCharCode(i);
          }
        }
        t = Base64._utf8_decode(t);
        return t;
      },
      _utf8_encode: function (e) {
        e = e.replace(/\r\n/g, "\n");
        let t = "";
        for (let n = 0; n < e.length; n++) {
          let r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
          } else if (r > 127 && r < 2048) {
            t += String.fromCharCode((r >> 6) | 192);
            t += String.fromCharCode((r & 63) | 128);
          } else {
            t += String.fromCharCode((r >> 12) | 224);
            t += String.fromCharCode(((r >> 6) & 63) | 128);
            t += String.fromCharCode((r & 63) | 128);
          }
        }
        return t;
      },
      _utf8_decode: function (e) {
        let t = "";
        let n = 0;
        let r = 0;
        let c2 = 0;
        while (n < e.length) {
          r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
            n++;
          } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
            n += 2;
          } else {
            c2 = e.charCodeAt(n + 1);
            let c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode(
              ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            n += 3;
          }
        }
        return t;
      },
    };
    let string = token;
    let decodedString = Base64.decode(string);
    replacedArray = decodedString.replace(/}{/, "},{");

    replacedArray = decodedString.substring(0, decodedString.length - 138);
    let createingJson = [{ response: replacedArray }];
    let aaa = createingJson[0].response;
    if (aaa.includes('"acCustomerId":20') == true) {
      this.correlateTT = false;
    } else {
      this.correlateTT = true;
    }

    if (this.refreshRate) {
      this.interval = setInterval(() => {
        this.pageIndex = 1;
        this.gridData = [];
        this.rowData = [];
        this.alarmHistoryGridFunction();
      }, this.refreshRate);
    } else {
      this.interval = setInterval(() => {
        this.pageIndex = 1;
        this.gridData = [];
        this.rowData = [];
        this.alarmHistoryGridFunction();
      }, 180000);
    }
  }
  interval;
  ngOnInit() {
    this.showLoader = true;
    this.alarmHistoryGridFunction();
  }
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  alarmHistoryGridFunction() {
    this.showLoader = true;
    const getDataJson = {
      fmID: 304,
      PageIndex: this.pageIndex,
      RecordPerPage: this.recordsPerRequest,
      SiteID: "",
      AlrID: [this.selectedAlarmPinId],
      Export: 0,
      Order: "Order By",
      OrderBy: "5",
      Sort: "DESC",
    };
    this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.alarmlastStatusUrl,
        getDataJson
      )
      .subscribe(
        (res) => {
          this.gridData1 = [];
          this.showLoader = false;
          const resp = res.response[0];
          let groupHeader = resp.Header.columns;
          let groupedData = this.groupHeader.transform(groupHeader);

          this.headers = groupedData;
   
          this.columnDefs = this.headers;
          this.gridData1 = resp.data;
          for (let i = 0; i < this.gridData1.length; i++) {
            this.gridData.push(this.gridData1[i]);
          }
          if (this.headers != undefined && this.headers != null) {
            this.disableHisExport = false;
          } else {
            this.columnDefs = [];
            this.disableHisExport = true;
          }
          if (this.gridData && this.gridData.length > 0) {
            this.createRowData();
            this.disableHisExport = false;
          } else {
            this.rowData = [];
            this.disableHisExport = true;
          }
          if (this.gridData1.length < this.recordsPerRequest) {
            this.disablelastbutton = true;
          } else {
            this.disablelastbutton = false;
          }
          this.gridApi.setRowData(this.rowData);
        },
        (error) => {
          console.error(error);
          this.showLoader = false;
        }
      );
  }
  createRowData() {
    this.rowData = this.gridData;
  }
  ngAfterViewChecked() {
    $("span.ag-paging-page-summary-panel").addClass("remi");
  }
  ngBeforeViewInit() {
    if (this.globals.message != "" && this.globals.messageType != "") {
      this.alerts = [];
      this.alerts.push({
        type: this.globals.messageType,
        message: this.globals.message,
      });
    }
    this.ngOnInit();
  }
  public excelStyles: ExcelStyle[] = [
    {
      id: "dateLong",
      dataType: "DateTime",
      numberFormat: {
        format: "dd/mm/yyy h:mm:ss",
      },
    },
  ];
  alarmHistoryExport(type) {
    let colKeyArr = [];
    const columnVal = this.gridColumnApi.getAllGridColumns();
    columnVal.forEach((element) => {
      if (element.visible == true) {
        if (!(element.colId == "action")) {
          colKeyArr.push(element.colId);
        }
      }
    });
    var params = {
      skipHeader: false,
      columnGroups: true,
      skipFooters: false,
      skipGroups: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      suppressQuotes: false,
      allColumns: false,
      onlySelected: false,
      columnKeys: colKeyArr,
      fileName: "AlarmHistoryReport",
      sheetName: "AlarmHistorydetails",
    };
    if (type == "csv") {
      this.gridApi.exportDataAsCsv(params);
    } else if (type == "xls") {
      this.gridApi.exportDataAsExcel(params);
    }
  }
  close(alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  onPageSizeChanged() {
    this.recordsPerRequest = this.alarmsShowRecordSize;
    this.rowData = [];
    this.gridData = [];
    this.pageIndex = 1;
    this.gridApi.paginationSetPageSize(Number(this.recordsPerRequest));

    this.alarmHistoryGridFunction();
  }

  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }
  onBtLast() {
    this.pageIndex += 1;
    this.alarmHistoryGridFunction();
    this.gridApi.paginationSetPageSize(this.alarmsShowRecordSize);
  }
  onBtNext() {
    this.gridApi.paginationGoToNextPage();
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage();
  }

  calculateRowCount() {
   
    this.recordSize = "0";
    this.pageNumber = "0";
    if (this.gridOptions.api && this.rowData) {
      const model = this.gridOptions.api.getModel();
      const totalRows = this.rowData.length;
      const processedRows = model.getRowCount();
      this.rowCount =
        processedRows.toLocaleString() + " / " + totalRows.toLocaleString();
    }
  }
  alarmCorrelate(content) {
    this.openModalService.OpenModel(content, "");
  }
 

  public onReady(datas) {
    this.gridApi = datas.api;
    this.gridColumnApi = datas.columnApi;
    this.recordSize = this.gridApi.paginationGetPageSize();
    this.pageNumber = this.gridApi.paginationGetCurrentPage();
    this.calculateRowCount();
    this.onPageSizeChanged();
  }

  onSelectionChanged() {
    this.correlateArr = [];
    let rowsSelection = this.gridApi.getSelectedRows();

    if (rowsSelection.length > 1) {
      this.correlateDisable = false;
    } else {
      this.correlateDisable = true;
    }

    rowsSelection.forEach((element) => {
      this.correlateArr.push({
        AlarmID: element.alarmid,
        Name: element.alarms,
        OpenTime: element.generatedOn,
        IsPrimaryAlarm: this.selectedRowVal,
      });
    });
  }

  backBtnClicked() {
    const link = "#/106";
    window.open(link, "_self");
  }
  onRadioBtnClicked(val) {
    this.selectedAlarm = val;
    this.createTTBtn = false;
  }

  createSelectedTT() {
    this.updateItem(this.selectedAlarm);
  }

  updateItem(newItem) {
    for (let i = 0; i < this.correlateArr.length; i++) {
      if (this.correlateArr[i].AlarmID == newItem) {
        this.correlateArr[i].IsPrimaryAlarm = 1;
      }
    }
    let jsonData = {
      siteID: this.selectedSiteId,
      Alarms: this.correlateArr,
    };
    this.modalService.dismissAll();
    this.http
      .post(environment.wfmurl + this.apiUrl.ttCreationUrl, jsonData)
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res.body);
          this.ngOnInit();
          const resp = JSON.parse(getImgResp);
          if (resp.Status == "Success") {
            this.alerts.push({
              type: "success",
              message: resp.Message,
            });
          } else {
            this.alerts.push({
              type: "danger",
              message: resp.Message,
            });
          }
        },
        (error) => {
          this.modalService.dismissAll();
        }
      );
  }
  downloadPdf() {
    let getDataJson = {
      PageIndex: 0,
      RecordPerPage: 0,
      SiteID: this.selectedSiteId,
      AlarmDisplayMode: 3,
      PDF: 1,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.alarmGridUrl,
        getDataJson
      )
      .subscribe((res) => {
        const getImgResp: string = JSON.stringify(res.body);
        const resp = JSON.parse(getImgResp);
        if (resp.Status == "1") {
          FileSaver.saveAs(
            this.urlAuthentication.itocUrl + "PDFReports/" + resp.Message
          );
        } else {
          alert(resp.Message);
        }
      });
  }
  onRecordSizeChanged() {
    const value = (<HTMLInputElement>document.getElementById("page-size"))
      .value;
    this.gridApi.paginationSetPageSize(Number(value));
    this.recordSize = this.gridApi.paginationGetPageSize();
    this.pageNumber = this.gridApi.paginationGetCurrentPage();
  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.lastPageFound = this.gridApi.paginationIsLastPageFound();
      this.PageSize = this.gridApi.paginationGetPageSize();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.totalPage = this.gridApi.paginationGetTotalPages();
      this.totalRowCount = this.gridApi.getDisplayedRowCount();
    }
  }
  ngOnDestroy() {
    this.modalService.dismissAll();
    if (this.interval) {
      clearInterval(this.interval);
    }
    $(".ag-paging-page-summary-panel").removeClass("remi");
  }
  public onCellClicked($event) {}
}
